import defaultLocale from "../../locale/fa-IR/index.js";
export default defaultLocale;